import React from 'react'

const Chevron = () => (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <polygon points="21 13 21.7071068 13.7071068 16.3535534 19.0606602 11 13.7071068 11.7071068 13 16.3535534 17.6464466" />
    </svg>
)

export default Chevron
